export default __webpack_public_path__ + "static/media/hamburger_open.4bfda4a7.svg";